import { SxProps, Theme } from '@mui/system';

const styles = {
  buttonContainer: {
    marginY: '10px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
